export default __webpack_public_path__ + "static/brochure-featured-image-ead00adc13ca981390157740cbc90fce.png";